import { useLibraryCoverUrl } from "@/hooks/useLibraryCoverUrl";

export const CoverThumb = ({ url, alt, className }: { url: string; alt: string; className: string }) => {
  const resolved = useLibraryCoverUrl(url);
  if (!resolved) {
    return <div className={`${className} flex items-center justify-center bg-muted text-[10px] text-muted-foreground`}>Loading…</div>;
  }
  return (
    <img
      src={resolved}
      alt={alt}
      className={className}
      onError={(e) => { (e.currentTarget as HTMLImageElement).style.opacity = "0.3"; }}
    />
  );
};
